import { ServicoNotarialInfoDTO } from './../../entity/ServicoNotarialInfoDTO';
import { Injectable } from '@angular/core';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import { catchError, retry } from 'rxjs/operators';
import { ConsultaVO } from 'src/app/entity/ConsultaVO';
import { URL_API } from 'src/app/tools/URL';
import { ATUALIZAR, CARREGAR, ENVIAR, ErrorsService, SALVAR } from '../errors/errors.service';
import { RestService } from '../rest.service';
import { AuthService } from '../autenticacao/auth.service';
import { RestituicaoRequest } from 'src/app/view/manifestos/consulta/cartorios-extrajudicial-consulta/partials/restituicao-form/restituicao-form.dto';

export interface ConsultaComRestituicaoDTO {
  consulta: ConsultaVO;
  restituicao: RestituicaoRequest;
}

@Injectable({
  providedIn: 'root'
})
export class ConsultaService {
  consulta = this.builder.group(this.preencherVo());

  constructor(
    private rest: RestService,
    private builder: FormBuilder,
    private errorsService: ErrorsService,
    private authService: AuthService) { }

    carregarDados() {
      return this.rest.get(`${URL_API.PATH_CONSULTA}/carregar`).pipe(
        retry(1),
        catchError(response => this.errorsService.handleError(response, CARREGAR))
      );
    }

    carregarDadosService() {

      this.carregarDados().subscribe(retorno => {
        this.consulta.controls.listaClassificacaoCompleta.setValue(retorno.listaClassificacaoCompleta);
        this.consulta.controls.assuntos.setValue(retorno.assuntos);
      });

    }

    carregarPorId(id: number) {

      return this.rest.get(`${URL_API.PATH_CONSULTA + '/' + id}`);

    }

    gravarManifestoOperador(manifestante, arquivos = [], isEnviar) {

      this.consulta.controls.nome.setValue(manifestante.nome);
      this.consulta.controls.email.setValue(manifestante.email);
      this.consulta.controls.username.setValue(this.authService.usuarioLogado.username);

      this.consulta.controls.files.setValue([]);
      arquivos.forEach((value, key) => {
        this.consulta.value.files.push({
          nomeArquivo: key,
          conteudo: value
        });
      });

      return isEnviar ? this.enviar(this.consulta.value) : this.salvar(this.consulta.value);

    }

    salvar(obj) {
      if (obj.id == null) {
        return this.gravar(obj);
      } else {
        return this.atualizar(obj);
      }
    }

    public enviar(obj: ConsultaVO) {
      return this.rest.post(`${URL_API.PATH_CONSULTA}/enviar`, obj).pipe(
        catchError(response => this.errorsService.handleError(response, ENVIAR))
      );
    }

    public enviarConsultaComRestituicao(dto: ConsultaComRestituicaoDTO) {
      return this.rest.post(`${URL_API.PATH_CONSULTA}/enviar/consulta-restituicao`, dto).pipe(
        catchError(response => this.errorsService.handleError(response, ENVIAR))
      );
    }

    private gravar(obj: ConsultaVO) {
      return this.rest.post(`${URL_API.PATH_CONSULTA}/salvar`, obj).pipe(
        catchError(response => this.errorsService.handleError(response, SALVAR))
      );
    }

    private atualizar(obj) {
      return this.rest.put(`${URL_API.PATH_CONSULTA}/salvar/${obj.id}`, obj).pipe(
        catchError(response => this.errorsService.handleError(response, ATUALIZAR))
      );
    }

    // TODO Completar busca e mapear ela no backend
     buscarInformacoesServentia(numeroCNS : number){
      return this.rest.get(`${URL_API.PATH_CONSULTA + '/buscaInfoServentia/' + numeroCNS}`);
    }

    preencherVo() {
      return {
        id: null,
        files: null,
        username: new FormControl(null),
        dataHoraAbertura: null,
        nome: new FormControl({ value: null }, [Validators.required]),
        email: new FormControl({ value: null }, [Validators.required]),
        assunto: new FormControl(null, [Validators.required]),
        descricaoConsulta: new FormControl(null, [Validators.required]),
        listaClassificacao: new FormControl([], [Validators.required]),
        listaClassificacaoCompleta: [],
        assuntos: [],
        codigoCNS: new FormControl(null, [Validators.required]),
        codigoCNSFormatado: new FormControl(null),
        nomeResponsavelServentia: new FormControl({ value: null, disabled: false }, [Validators.required]),
        nomeMunicipioServentia: new FormControl({ value: null, disabled: false }, [Validators.required]),
        nomeServentia: new FormControl({ value: null, disabled: false }, [Validators.required]),
        codigoMunicipioServentia: new FormControl(null),
        tipoClassificacao: new FormControl(null),
        codigoComarca: new FormControl(null),
        demandaRecebida: new FormControl(null),
        dadosRequerente: this.builder.group({}),
        listaConciliador: this.builder.array([]),
        termoDeclaracaoVerdade: new FormControl(null),
        monitoramentoConciliacao: new FormControl(null)
      } as ConsultaVO;
    }

  criarConciliadorForm(arquivoObrigatorio = false): FormGroup {
    return this.builder.group({
        id: [null],
        cpf: ['', [Validators.required, Validators.pattern(/^\d{3}\.\d{3}\.\d{3}-\d{2}$/)]],
        nome: ['', Validators.required],
        telefone: ['', Validators.required],
        email: ['', [Validators.required, Validators.email]],
        funcao: ['', Validators.required],
        atuacao: ['', Validators.required],
        arquivo: this.builder.array([], arquivoObrigatorio? Validators.required : null),
        requerente: ['0']
    });
  }
}
